module.exports = __webpack_public_path__ + "static/media/facebook-icon.48af97c1.svg";